export default {
    title: "Pregled narudžbine",
    cardTitle: "Plaćanje online",
    cashOnDeliveryTitle: "Plaćanje pouzećem",
    paymentInfo: 'Ovi proizvodi nemaju opciju plaćanja karticom. Njihovo plaćanje ce se vršiti pouzećem. Na dugme ispod možete odustati od kupovine istih.',
    priceSummary: {
        productSum: "Suma proizvoda",
        delivery: "Dostava",
        surcharge: "Doplata",
        total: "Ukupno"
    }
}
